import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

import { standardStyles } from "@components/suggestion-card-header/SuggestionCardHeader.styles";

const container: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  borderBottom: standardStyles.container.borderBottom,
};

const iconButton: CSSProperties = {
  padding: 8,
};

const leftArrow: CSSProperties = {};

const rightArrow: CSSProperties = {};

const dotContainer: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
};

const dot: CSSProperties = {
  height: 8,
  width: 8,
  borderRadius: "50%",
  backgroundColor: greys.paleGrey,
  marginLeft: 8,
  cursor: "pointer",
  transition: "all .1s ease-in-out",
  "&:hover": {
    backgroundColor: greys.slate,
    transform: "scale(1.1)",
  },
  "&:first-child": {
    marginLeft: 0,
  },
};

const selected: CSSProperties = {
  backgroundColor: greys.slate,
};

export const styles = {
  container,
  iconButton,
  leftArrow,
  rightArrow,
  dotContainer,
  dot,
  selected,
};
